export default {
    init() {
        var profile_container = $('.profiles');
        if (profile_container.length) {
            profile_container.find('.name').matchHeight();
            profile_container.find('.title').matchHeight();
            console.log('here');
        }
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAboutUs.js